import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";

const FIELDS = [["headline", "Headline", 70], ["subline", "Sub-line", 140], ["cta", "Button text", 28], ["caption", "Post caption", 1200], ["voiceover", "Voiceover script", 400]];

export function EditCopyDialog({ item, lang, onClose, onSaved }) {
  const [v, setV] = useState(() => Object.fromEntries(FIELDS.map(([k]) => [k, item.copy[lang][k] || ""])));
  const [saving, setSaving] = useState(false);
  const save = () => {
    setSaving(true);
    api.patch(`/admin/content/${item.item_id}`, { lang, copy_edit: v }).then((r) => { onSaved(r.data); toast.success("Saved. Tap Remake to update the media."); onClose(); })
      .catch((e) => toast.error(formatErr(e))).finally(() => setSaving(false));
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="edit-copy-dialog">
        <DialogHeader><DialogTitle>Edit {lang === "es" ? "Spanish" : "English"} copy</DialogTitle></DialogHeader>
        <div className="space-y-3">
          {FIELDS.map(([k, l, max]) => (
            <label key={k} className="block text-xs font-semibold text-slate-600">{l}
              {max > 140
                ? <Textarea value={v[k]} maxLength={max} rows={k === "caption" ? 4 : 3} onChange={(e) => setV({ ...v, [k]: e.target.value })} className="mt-1" data-testid={`edit-copy-${k}`} />
                : <Input value={v[k]} maxLength={max} onChange={(e) => setV({ ...v, [k]: e.target.value })} className="mt-1" data-testid={`edit-copy-${k}`} />}
            </label>
          ))}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button onClick={save} disabled={saving} className="bg-emerald-600 hover:bg-emerald-700" data-testid="edit-copy-save">Save</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
